// This file is auto-generated by the `scripts/wallets/generate.ts` script.
// Do not modify this file manually.
export const wallet = {
    id: "io.trinity-tech",
    name: "Essentials",
    homepage: "https://www.trinity-tech.io/essentials",
    image_id: "058878f4-7364-4e01-434f-2cc09a15cf00",
    app: {
        browser: null,
        ios: "https://apps.apple.com/us/app/elastos-essentials/id1568931743",
        android: "https://play.google.com/store/apps/details?id=org.elastos.essentials.app",
        mac: "",
        windows: null,
        linux: null,
        chrome: null,
        firefox: null,
        safari: null,
        edge: null,
        opera: null,
    },
    rdns: null,
    mobile: {
        native: null,
        universal: "https://essentials.web3essentials.io",
    },
    desktop: {
        native: null,
        universal: null,
    },
};
//# sourceMappingURL=index.js.map